import React from 'react';

import { CategoryDashboard } from '../modules/audience-category-dashboard';

const sortingOptions = [
    {
        label: 'Sort by: Name',
        value: 'name',
        direction: 'asc',
    },
    {
        label: 'Sort by: Newest',
        value: '_created',
        direction: 'desc',
    },
    {
        label: 'Sort by: Last Updated',
        value: 'lastRefreshed',
        direction: 'desc',
    },
];

const BehaviouralVisitationLayout = ({
    audienceSegments,
    onSearch,
    segmentCount,
    activeAudience,
    organizationId,
}) => {
    const linkToAudienceTab = {
        pathname: '/audiences/all',
        query: { audienceTab: 'pelmorex_data' },
        linkBackLabel: 'Pelmorex Data',
    };

    return (
        <CategoryDashboard
            audienceSegments={audienceSegments}
            onSearch={onSearch}
            segmentCount={segmentCount}
            activeAudience={activeAudience}
            organizationId={organizationId}
            sortingOptions={sortingOptions}
            description={
                'Analyzing real-world visitation patterns and frequency, these segments identify consumers demonstrating distinct lifestyles or habitual interests (eg., Golf Enthusiasts).'
            }
            title={'Behavioural Visitation'}
            linkToAudienceTab={linkToAudienceTab}
            bannerImagePath={'/images/audience-segments/banners/behavioural visitation-banner.png'}
        />
    );
};

export default BehaviouralVisitationLayout;
